// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"7f389a79","356":"e5ffd1f2","434":"6cc5919f","602":"b3d09cdf","905":"4c0051ec"}[chunkId] + ".chunk.css";
};